import { Popup, Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

type Props = {
  selectedView: any;
  actions: any;
  entityType: string;
  setSelectedView: (arg0: any) => void;
};

const FavoriteUnfavoriteButton = ({
  selectedView,
  actions,
  entityType,
  setSelectedView,
}: Props) => {
  const fav = selectedView.isFavorite;
  const [favorite, setFavorite] = useState(fav);
  useEffect(() => {
    setFavorite(fav);
  }, [fav]);
  const { t } = useTranslation();
  const onUnfavoriteButton = () => {
    actions.favoriteUnfavoriteDataView(selectedView.value, entityType);
    setSelectedView({ ...selectedView, isFavorite: false });
    setFavorite(false);
  };

  const onFavouriteButton = () => {
    actions.favoriteUnfavoriteDataView(selectedView.value, entityType);
    setSelectedView({ ...selectedView, isFavorite: true });
    setFavorite(true);
  };

  return favorite ? (
    <Popup
      key="unfavoriteDataViewToolTip"
      trigger={
        <Button
          icon="star"
          type="button"
          onClick={() => {
            onUnfavoriteButton();
          }}
          className="mini"
        />
      }
      size="mini"
      content={t('overview.page.data.view.unfavorite.tooltip')}
      position="top left"
    />
  ) : (
    <Popup
      key="favoriteDataViewToolTip"
      trigger={
        <Button
          icon="star outline"
          type="button"
          on="click"
          position="left"
          onClick={() => {
            onFavouriteButton();
          }}
          className="mini"
        />
      }
      size="mini"
      content={t('overview.page.data.view.favorite.tooltip')}
      position="top left"
    />
  );
};

export default FavoriteUnfavoriteButton;
